import { useEffect, useState } from "react";
import liff from "@line/liff";
import { RiLineFill } from "react-icons/ri";
import { Text, View, XStack, YStack } from "tamagui";

import { colors } from "@styles/colors";

/**
 * 是不是瓦斯行官方帳號的好友（2026-10-20）：只有在 LINE 裡（LIFF 已登入）問得到。
 * 問不到（付款連結在 LINE 外開、LIFF 沒連結官方帳號）回 null，呼叫端就不要顯示加好友。
 */
export function useOaFriendship(): boolean | null {
  const [isFriend, setIsFriend] = useState<boolean | null>(null);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        if (!liff.isLoggedIn()) return;
        const r = await liff.getFriendship();
        if (alive) setIsFriend(r.friendFlag);
      } catch {
        // LIFF 沒初始化或沒連結官方帳號：問不到
      }
    })();
    return () => {
      alive = false;
    };
  }, []);
  return isFriend;
}

/** LINE 的品牌綠（加好友按鈕用 LINE 自己的顏色，一眼認得是加 LINE 好友） */
const LINE_GREEN = "#06C755";

/**
 * 付款完成後，偵測到還不是瓦斯行官方帳號好友時顯示（2026-10-20）：加好友才收得到配送、付款通知。
 * 所有身分都顯示；只在 LINE 裡偵測得到，LINE 外開的付款連結問不到就不顯示。
 */
export const AddFriendCard = ({ supplierName, url }: { supplierName: string; url: string }) => (
  <XStack
    width="100%"
    bg={colors.light}
    br={24}
    px={16}
    py={14}
    gap="$3"
    ai="center"
    style={{ boxShadow: "0 2px 10px -4px rgba(21, 101, 192, 0.10)" }}
  >
    <View w={38} h={38} br={12} bg="#E8F9EF" ai="center" jc="center" flexShrink={0}>
      <RiLineFill size={22} color={LINE_GREEN} />
    </View>
    <YStack flex={1} minWidth={0} gap={2}>
      <Text fontSize={13.5} fontWeight="800" color={colors.text} numberOfLines={1}>
        加入{supplierName ? `「${supplierName}」` : "瓦斯行"}好友
      </Text>
      <Text fontSize={11.5} color={colors.sub}>
        配送、付款進度會直接傳到 LINE
      </Text>
    </YStack>
    <a href={url} style={{ textDecoration: "none", flexShrink: 0 }}>
      <XStack br={999} px={14} py={8} bg={LINE_GREEN} pressStyle={{ opacity: 0.85 }} cursor="pointer">
        <Text fontSize={13} fontWeight="800" color={colors.light}>
          加入好友
        </Text>
      </XStack>
    </a>
  </XStack>
);
